export enum ResourceViewModes {
  List = "list",
  Card = "card",
  Calendar = "calendar"
}
